import { DataStateManager, useDataState } from '../../../..';

import { useCallback, useMemo } from 'react';

import type { TpcPriceModifier as TPM } from '../../..';

export const useData = <K extends Args.Key>({ price, field }: Args.Type<K>): Args.Hook<K> => {
	const manager = useDataState();

	const onChange: Args.Hook<K>['onChange'] = useCallback(
		(eventOrValue) => {
			const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
			manager.updatePrice({ id: price.id, fieldValues: { [field]: value } });
		},
		[manager, price.id, field]
	);

	return useMemo(
		() => ({
			isDisabled: manager.isDisabled,
			manager,
			onChange,
			reverseCalculate: manager.reverseCalculate,
			value: price[field],
		}),
		[manager, onChange, price, field]
	);
};

namespace Args {
	export type Type<K extends Key> = {
		price: TPM;
		field: K;
	};
	export type Key = keyof TPM;
	export type Value<K extends Key> = TPM[K];
	export type Hook<K extends Key> = {
		isDisabled?: boolean;
		manager: DataStateManager;
		onChange: OnChange.Type;
		reverseCalculate: boolean;
		value: Value<K>;
	};
}

namespace OnChange {
	export type Type = Input & Select;

	type Input = React.ChangeEventHandler<HTMLInputElement>;
	type Select = React.ChangeEventHandler<HTMLSelectElement>;
}
